




















import { Component } from 'vue-property-decorator';
import CurrentTimeMixin from '@/mixin/current-time.mixin';

@Component<TimeStamp>({})
export default class TimeStamp extends CurrentTimeMixin {}
